import { plainToClass } from "class-transformer";
import { IFilter, InitializeFilterDropdown } from "../../../shared/scripts/dropdown-functions";
import { TableColumnGroup, TableColumnVisibilityControllerV2 } from "../../../shared/scripts/table-column-visibility";

import _ from 'lodash';

import { ListItem, ListInformation } from "./list-management.objects";
import { Section } from "./list-management.form-sections";

export class ListTables {
    listId: string;
    propId: string;
    columns: any[];
    tableColumnGroups: TableColumnGroup[];
    items: ListItem[];

    selectTableId: string;
    selectTable: any;
    selectTableController: TableColumnVisibilityControllerV2;
    selectedItems: any[];

    editTableId: string;
    editTable: any;
    editTableController: TableColumnVisibilityControllerV2;

    editSections: Section[];

    targetItem: any;

    constructor(listId: string, info: ListInformation, items: ListItem[], editSections: Section[]) {
        this.listId = listId;
        this.selectTableId = `${this.listId}-select-table`;
        this.editTableId = `${this.listId}-edit-table`;
        this.columns = info.columns;
        this.tableColumnGroups = info.tableColumnGroups;
        this.propId = info.propId;
        this.items = items;
        this.editSections = editSections;
        this.selectedItems = [];
        this.targetItem = null;
        this.initialize();
        this.initializeTableCheckbox();
    }

    initialize() {
        let columns = _.cloneDeep(this.columns);
        let editColumns = _.cloneDeep(this.columns);

        // Select Table
        let selectColumns: any[] = [
            { title: `<div class="form-check"><input id="${this.listId}-select-all" class="form-check-input" type="checkbox"></div>`, orderable: false, width: "15px", className: "text-center item-select-option", data: { _: "IsSelected", display: "SelectorDisplay" } }
        ];
        let firstColumn = columns.shift();
        if (firstColumn) {
            selectColumns.push(firstColumn);
            selectColumns.push(
                { data: this.propId, title: "", width: "26px", orderable: false, className: "text-center detail-btn-container", render: (data) => this.renderDetailButton(data) }
            )
        }
        selectColumns.push(...columns);

        this.selectTable = $(`#${this.selectTableId}`).DataTable({
            "dom": `<"${this.listId}-top-controls"<"${this.listId}-column-select"><"${this.listId}-search-bar"f><"${this.listId}-count-found"B>>rtip`,
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            //responsive: false,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 3
            },
            language:
            {
                search: "Search",
            },
            columns: selectColumns,
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                }
            ],
            data: this.items,
            order: [[1, 'asc']],
            initComplete: (settings, json) => {

            },
        });

        $(`.${this.listId}-top-controls`).addClass('row mx-0 align-items-center');

        $(`.${this.listId}-column-select`).addClass('col-12 col-md-3 px-0 mb-2');
        $(`.${this.listId}-column-select`).empty().html(`<div id="${this.listId}-column-select"></div>`);
        $(`.${this.listId}-search-bar`).addClass('col-12 col-md-3');
        $(`.${this.listId}-count-found`).addClass('col-12 col-md-6 d-flex justify-content-end vertical-align-middle mt-3 px-0');
        $(`.${this.listId}-count-found`).prepend('<div id="selected-items-block" class="align-self-center pr-3"></div>');

        this.selectTableController = new TableColumnVisibilityControllerV2(`#${this.selectTableId}`, `#${this.listId}-column-select`, this.tableColumnGroups, `${this.listId}-table-column-visibility`);

        $(`#${this.selectTableId} tbody`).on('click', 'td', (event) => {
            let td = $(event.currentTarget);
            if (td.hasClass("item-select-option")) {
                this.updateSelector(td.find(".form-check-input").first());

                // also hide any dropdown menus
                $("#detail-menu-container").find(".revampp-dropdown-menu").removeClass("show");
                return;
            }
        });

        // Edit Table
        this.editTable = $(`#${this.editTableId}`).DataTable({
            "dom": `<"${this.listId}-edit-top-controls"<"${this.listId}-edit-column-select">>rtip`,
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '50vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 1
            },
            columns: editColumns,
            data: this.selectedItems,
            order: [[0, 'asc']],
            initComplete: (settings, json) => {

            },
        });

        $(`.${this.listId}-edit-top-controls`).addClass('row mx-0 align-items-center');
        $(`.${this.listId}-edit-column-select`).addClass('col-12 col-md-3 px-0 mb-2');
        $(`.${this.listId}-edit-column-select`).empty().html(`<div id="${this.listId}-edit-column-select"></div>`);

        this.editTableController = new TableColumnVisibilityControllerV2(`#${this.editTableId}`, `#${this.listId}-edit-column-select`, this.tableColumnGroups, `${this.listId}-edit-table-column-visibility`);

        // Ensure the Edit Modal's table columns match the select tables
        $(`#column-filter-dropdown-${this.listId}-table-column-visibility`).on("change", () => {
            $(`#column-filter-dropdown-${this.listId}-edit-table-column-visibility`).val($(`#column-filter-dropdown-${this.listId}-table-column-visibility`).val())
            $(`#column-filter-dropdown-${this.listId}-edit-table-column-visibility`).trigger("change");
        });

        // Resize on tab selection
        $("#edit-table-tab").off().on('shown.bs.tab', () => this.resizeTable());
    }

    renderDetailButton(data: any): string {

        let content = `
            <div class="btn-group dropright">
                <button type="button" class="btn dropdown-toggle p-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onclick="page.currentListController.listTables.updateMenuPosition(event)">
                    <div class="item-detail-button" data-id="${data}"><div><i class="fa-solid fa-ellipsis"></i></div></div>
                </button>
                <div class="dropdown-menu revampp-dropdown-menu">
                    
                </div>
            </div>
        `
        return content;
    }

    initializeTableCheckbox(): void {
        let selectAllCheckboxId = `#${this.listId}-select-all`;
        $(selectAllCheckboxId).on('click', () => {
            $(selectAllCheckboxId).prop("indeterminate", false);

            if ($(selectAllCheckboxId).prop("checked")) {
                let visibleItems: ListItem[] = this.selectTable.rows().data().toArray();
                visibleItems.forEach(item => item.updateSelect(true));
                this.updateTable(visibleItems);
                this.setSelectedItemsLabel(visibleItems.length);
                this.setSelectedItems(this.getSelectedItems());
                $(`#${this.selectTableId}`).find("tr").addClass("row-selected");
            }
            else {
                this.clearSelectedItems();
            }
        })
    }

    resizeTable(): void {
        if (this.selectTable) {
            this.selectTable.columns.adjust().draw();
        }

        if (this.editTable) {
            this.editTable.columns.adjust().draw();
        }
    }

    updateFilteredItems(items: ListItem[]) {
        // Get selected items
        let selectedItems = this.getSelectedItems().map(item => item.Id);
        items = items.map(item => {
            if (!item.Id) {
                return item;
            }

            if (selectedItems.includes(item.Id)) {
                item.updateSelect(true);
            }

            return item;
        })

        this.updateTable(items);
        this.updateSelectorAll();

        // Set class on selected rows
        $(`#${this.selectTableId}`).find("input:checked").closest('tr').addClass("row-selected");
    }

    updateTable(items: ListItem[]) {
        // Removes any shown menus
        $("#detail-menu-container").empty();

        this.selectTable.clear();
        this.selectTable.rows.add(items).draw();
    }

    updateEditTable(useSelected: boolean = true) {
        this.editTable.clear();
        if (useSelected) {
            this.editTable.rows.add(this.selectedItems).draw();
        }
        else {
            this.editTable.rows.add([this.targetItem]).draw();
        }
    }

    clearSelectedItems(): void {
        let selectAllCheckboxId = `#${this.listId}-select-all`;
        $(selectAllCheckboxId).prop("checked", false);
        $(selectAllCheckboxId).prop("indeterminate", false);
        let visibleItems: ListItem[] = this.selectTable.rows().data().toArray();
        visibleItems.forEach(item => item.updateSelect(false));
        this.updateTable(visibleItems);
        this.setSelectedItems([])
        this.setSelectedItemsLabel(0);
    }

    updateSelector(checkbox: JQuery<HTMLElement>): void {
        let tr = $(checkbox).closest('tr');
        let row = this.selectTable.row(tr);
        let currentData: ListItem = row.data();
        let isChecked = !currentData.IsSelected;
        currentData.updateSelect(isChecked);
        row.data(currentData);

        if (isChecked) {
            $(tr).addClass("row-selected");
        }
        else {
            $(tr).removeClass("row-selected");
        }

        this.updateSelectorAll();
    }

    updateSelectorAll(): void {
        let visibleItems: ListItem[] = this.selectTable.rows().data().toArray();
        let selectedItems = this.getSelectedItems();
        let selectAllCheckboxId = `#${this.listId}-select-all`;
        if (visibleItems.length == selectedItems.length) {
            $(selectAllCheckboxId).prop("checked", true);
            $(selectAllCheckboxId).prop("indeterminate", false);
        }
        else if (selectedItems.length == 0) {
            $(selectAllCheckboxId).prop("checked", false);
            $(selectAllCheckboxId).prop("indeterminate", false);
        }
        else {
            $(selectAllCheckboxId).prop("checked", false);
            $(selectAllCheckboxId).prop("indeterminate", true);
        }

        this.setSelectedItems(selectedItems);
        this.setSelectedItemsLabel(selectedItems.length);
    }

    getSelectedItems(): ListItem[] {
        let visibleItems: ListItem[] = this.selectTable.rows().data().toArray();
        let selectedItems = visibleItems.filter(item => item.IsSelected);
        return selectedItems;

    }

    setSelectedItemsLabel(itemCount: number): void {
        if (itemCount == 0) {
            $("#selected-items-block").empty();
        }
        else {
            let text = ""
            if (itemCount == 1) {
                text = "1 Item Selected";
            }
            else {
                text = `${itemCount} Items Selected`
            }

            let content = `
                <div class="btn-group" role="group">
                    <div class="selected-items-text font-size13">
                        <i class="fa-solid fa-xmark fa-lg clear-selected-btn pr-2" onclick='page.currentListController.listTables.clearSelectedItems()'></i> ${text}
                    </div>

                    <div class="btn-group revampp-btn-dropdown" role="group">
                        <button id="editItemOptions" type="button" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Edit
                        </button>
                        <div class="dropdown-menu dropdown-menu-right revampp-dropdown-menu" aria-labelledby="editItemOptions">
                            ${this.getMenuContent()}
                        </div>
                    </div>
                </div>

            `

            $("#selected-items-block").empty().html(content);
        }
    }

    setSelectedItems(selectedItems: any[]): void {
        this.selectedItems = selectedItems;
    }

    updateMenuPosition(e: Event) {
        // set current selected row
        let targetElement = <JQuery<HTMLElement>>$(e.currentTarget);
        this.setTargetedRow(targetElement);

        // empty any existing menus (menus are moved to this div to avoid overflow issues with table)
        $("#detail-menu-container").empty();

        let dropdownMenu = targetElement.siblings('.revampp-dropdown-menu');
        let dropdownContainer = targetElement.parent();

        // Check is the dropdown menu has been moved to the new #detail-menu-container 
        if (dropdownMenu.length <= 0) {
            // if the menu has already been moved, remove existing dropdwon relationship, and create a new one with new menu options
            targetElement.dropdown('dispose');
            dropdownContainer.append(`
                <div class="dropdown-menu revampp-dropdown-menu">
                    ${this.getMenuContent(this.checkIsSelected(targetElement))}
                </div>
            `)          
            targetElement.dropdown();
            // move the updated menu to #detail-menu-container when its shown
            dropdownContainer.off().on("show.bs.dropdown", (e) => {
                let updatedDropdownMenu = dropdownContainer.find('.revampp-dropdown-menu');
                $("#detail-menu-container").append(<JQuery<HTMLElement>>$(updatedDropdownMenu))
            });
        }
        else {
            // if the menu has not already been moved (first click), just add the correct menu options.
            dropdownMenu.html(`
                ${this.getMenuContent(this.checkIsSelected(targetElement))}
            `)
            // move the updated menu to #detail-menu-container when its shown
            dropdownContainer.off().on("show.bs.dropdown", (e) => {
                let updatedDropdownMenu = dropdownContainer.find(".revampp-dropdown-menu");
                $("#detail-menu-container").append(<JQuery<HTMLElement>>$(updatedDropdownMenu));
            });
        }  
    }

    checkIsSelected(target: JQuery<HTMLElement>): boolean {
        let tr = $(target).closest('tr');
        let row = this.selectTable.row(tr);
        let currentData: ListItem = row.data();
        
        return currentData.IsSelected;
    }

    setTargetedRow(target: JQuery<HTMLElement>): void {
        let tr = $(target).closest('tr');
        let row = this.selectTable.row(tr);
        let currentData: ListItem = row.data();

        this.targetItem = currentData;
    }

    getMenuContent(useSelected: boolean = true): string {

        let menuOptions = "";

        let isMultipleSelected = this.getSelectedItems().length > 1;
        if (isMultipleSelected && useSelected) {
            menuOptions += `<div class="font-weight-bold font-size14 px-4 py-1">${this.getSelectedItems().length} Selected</div>`
        }


        this.editSections.forEach(section => {
            let option: string = `<a class="dropdown-item" onclick="page.currentListController.openEditModal('${section.id}', '${useSelected}')"><i class="${section.icon} dropdown-icon pr-2"></i> Edit ${section.title}</a>`
            if (isMultipleSelected && useSelected) {
                if (section.visibleEditMultiple) {
                    menuOptions += option;
                }
            }
            else {
                menuOptions += option;
            }

        })

        if (this.listId == "revampp-users") {
            let option: string = `<a class="dropdown-item" onclick="page.currentListController.openWelcomeEmailModal('${useSelected}')"><i class="fa-solid fa-envelope dropdown-icon pr-2"></i> Send Welcome Emails</a>`;
            menuOptions += option;
        }

        return menuOptions;
    }
}